export const navigationTranslations = {
  es: {
    nav: {
      about: "Nosotros",
      what: "Innovación",
      portfolio: "Portafolio",
      team: "Equipo",
      news: "Noticias",
      contact: "Contacto"
    }
  },
  en: {
    nav: {
      about: "About",
      what: "Innovation",
      portfolio: "Portfolio",
      team: "Team",
      news: "News",
      contact: "Contact"
    }
  }
};
